import { getCredentials } from "app/utils/auth";

export const checkIfNavlogEnabled = state => {
	const { token } = getCredentials(state.shop);
	return token && state.partner.enableNavLog;
};
